module.exports = __webpack_public_path__ + "static/media/banner_nav7.54ad9f6d.png";